export default __webpack_public_path__ + "static/media/data-science.502b9589.png";